export const CANVAS_PARAM = 'canvas';
export const CANVAS_VERSION_PARAM = 'canvasVersion';

/** Return the path to a chat with one of its canvases open, optionally pinned to a past version. */
export function canvasPath(sessionId: string, canvasId: string, opts?: { versionId?: number }): string {
  const params = new URLSearchParams({ [CANVAS_PARAM]: canvasId });
  if (opts?.versionId !== undefined) params.set(CANVAS_VERSION_PARAM, String(opts.versionId));
  return `/chat/${sessionId}?${params.toString()}`;
}

/** Open a canvas-backing document in its chat. A historical version is pinned; the current one is live. */
export function canvasDocumentPath(target: {
  session_id: string;
  canvas_id: string;
  version_id?: number | null;
}): string {
  return canvasPath(
    target.session_id,
    target.canvas_id,
    target.version_id != null ? { versionId: target.version_id } : undefined
  );
}
